import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/useAuth";

interface RequireAuthProps {
  children: ReactNode;
  role?: "admin";
}

export function RequireAuth({ children, role }: RequireAuthProps): JSX.Element {
  const { state } = useAuth();
  const location = useLocation();

  if (state.status === "loading") {
    return (
      <div className="flex min-h-full items-center justify-center text-sm text-zinc-500">
        会话验证中…
      </div>
    );
  }
  if (state.status === "anonymous") {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (role === "admin" && state.session.role !== "admin") {
    // Don't expose admin-only routes to regular users — bounce back home.
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
